<template>
  <modal ref='bulkDeleteProductsModal' class="upload-files-modal">
    <template #header>
      <h5 class="modal-title mt-0">{{ $t('bulk_products.delete.bulk_delete') }} </h5>
    </template>

    <template #body>
      <form class="modal-fix">
        <div class='modal-body'>
          <p> {{ $t('bulk_products.delete.remove_checked_items') }} </p>
        </div>

        <div class='modal-footer'>
          <a @click.prevent="closeModal()" class="btn btn-outline-primary float-right" href="">{{ $t('share_invite.close') }}</a>
          <a @click.prevent="bulkDeleteProducts" class="btn btn-danger float-right" href=""> {{ $t('bulk_products.delete.delete') }} </a>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import _modal from '../_modal'


export default {
  components: {
    'modal': _modal,
  },
  data: function () {
    return {
      productIds: [],
    }
  },
  methods: {
    open(products) {
      this.productIds = products
      this.$refs.bulkDeleteProductsModal.open()
    },
    closeModal() {
      this.$refs.bulkDeleteProductsModal.close()
    },
    bulkDeleteProducts(){
      this.store.bulkDeleteProducts({ params: { product_ids: this.productIds }}).then(() => {
        this.store.sendMetrics({name: 'bulk_delete_products', params: this.$route.params, path: this.$route.fullPath})
        this.$emit('success')
        this.$toastr.success(this.$t('bulk_products.delete.success'))
        this.closeModal()
      })
    }
  }
}
</script>
